import { DoubleOptInPageTypeEnum, ModalState } from "./types"

enum ModalStateActionType {
    OpenGallery = 'OPEN_GALLERY',
    CloseGallery = 'CLOSE_GALLERY',
    SetActivationTemplate = 'SET_ACTIVATION_TEMPLATE',
    SetActivationTemplateScreenshot = 'SET_ACTIVATION_TEMPLATE_SCREENSHOT',
    SetDoubleOptInPagePreviewUrl = 'SET_DOUBLE_OPT_IN_PAGE_PREVIEW_URL',
    ChangeDoubleOptInPageType = 'CHANGE_DOUBLE_OPT_IN_PAGE_TYPE',
    SetDoubleOptInPageValue = 'SET_DOUBLE_OPT_IN_PAGE_VALUE',
    SetDoubleOptInPageIsError = 'SET_DOUBLE_OPT_IN_PAGE_IS_ERROR',
    SetLandingPageSearchInputValue = 'SET_LANDING_PAGE_SEARCH_INPUT_VALUE',
    Reset = 'RESET',
}

export type ModalStateAction<T = any> = {
    type: ModalStateActionType,
    payload?: T
}

export const setActivationTemplateScreenshotAction = (screenshot?: string): ModalStateAction<string> => ({
    type: ModalStateActionType.SetActivationTemplateScreenshot,
    payload: screenshot
});

interface SetActivationTemplateActionProps {
    screenshot?: string;
    templateName?: string;
}

export const setActivationTemplateAction = (screenshot?: string, templateName?: string): ModalStateAction<SetActivationTemplateActionProps> => ({
    type: ModalStateActionType.SetActivationTemplate,
    payload: { screenshot, templateName }
});

export const setDoubleOptInPagePreviewUrlAction = (previewUrl?: string): ModalStateAction<string> => ({
    type: ModalStateActionType.SetDoubleOptInPagePreviewUrl,
    payload: previewUrl
});

export const changeDoubleOptInPageTypeAction = (doubleOptInPageType: DoubleOptInPageTypeEnum): ModalStateAction<DoubleOptInPageTypeEnum> => ({
    type: ModalStateActionType.ChangeDoubleOptInPageType,
    payload: doubleOptInPageType
});

interface SetDoubleOptInPageValueActionProps {
    value?: string;
    previewUrl?: string;
}

export const setDoubleOptInPageValueAction = (value: string, previewUrl?: string): ModalStateAction<SetDoubleOptInPageValueActionProps> => ({
    type: ModalStateActionType.SetDoubleOptInPageValue,
    payload: { value, previewUrl }
});

export const setDoubleOptInPageIsErrorAction = (isError: boolean): ModalStateAction<boolean> => ({
    type: ModalStateActionType.SetDoubleOptInPageIsError,
    payload: isError
});

export const setLandingPageSearchInputValueAction = (value: string): ModalStateAction<string> => ({
    type: ModalStateActionType.SetLandingPageSearchInputValue,
    payload: value
});

export const openGalleryAction: ModalStateAction = {
    type: ModalStateActionType.OpenGallery,
};

export const closeGalleryAction: ModalStateAction = {
    type: ModalStateActionType.CloseGallery,
};

export const resetAction: ModalStateAction = {
    type: ModalStateActionType.Reset,
}

export const modalStateReducer = (state: ModalState, action: ModalStateAction): ModalState => {
    const { type, payload } = action;

    switch (type) {
        case ModalStateActionType.ChangeDoubleOptInPageType: {
            const doubleOptInPageType = payload;
            return {
                ...state,
                doubleOptInPageType,
                isDoubleOptInPageError: false,
                doubleOptInPageValue: null,
                previewUrl: null,
                searchInput: null,
            }
        }
        case ModalStateActionType.SetActivationTemplateScreenshot: {
            const activationTemplateScreenshot = payload;
            return {
                ...state,
                activationTemplateScreenshot,
                isLoadingActivationTemplate: false,
            }
        }
        case ModalStateActionType.SetActivationTemplate: {
            const { screenshot, templateName } = payload;
            return {
                ...state,
                activationTemplateScreenshot: screenshot,
                activationTemplateName: templateName,
                isLoadingActivationTemplate: false,
                isGalleryOpen: false,
            }
        }
        case ModalStateActionType.SetDoubleOptInPagePreviewUrl: {
            const previewUrl = payload;
            return {
                ...state,
                previewUrl,
                isLoadingDoubleOptInPage: false,
            }
        }
        case ModalStateActionType.SetDoubleOptInPageValue: {
            const { value, previewUrl } = payload;
            return {
                ...state,
                doubleOptInPageValue: value,
                previewUrl,
                searchInput: null,
            }
        }
        case ModalStateActionType.SetDoubleOptInPageIsError: {
            const isDoubleOptInPageError = payload;
            return {
                ...state,
                isDoubleOptInPageError,
            }
        }
        case ModalStateActionType.SetLandingPageSearchInputValue: {
            const searchInput = payload;
            return {
                ...state,
                searchInput,
            }
        }
        case ModalStateActionType.OpenGallery:
            return {
                ...state,
                isGalleryOpen: true
            }
        case ModalStateActionType.CloseGallery:
            return {
                ...state,
                isGalleryOpen: false
            }
        case ModalStateActionType.Reset:
            return {
                ...state,
                doubleOptInPageType: DoubleOptInPageTypeEnum.Defaultpage,
                activationTemplateScreenshot: null,
                activationTemplateName: null,
                doubleOptInPageValue: null,
                isDoubleOptInPageError: false,
                searchInput: null,
                previewUrl: null,
            }
        default:
            return state;
    }
}
